<template>
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Sign in required.</p>
      </header>
      <section class="modal-card-body">
        <p>You need to be logged in/registered to view more info.</p>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="closeModal">
          Cancel
        </button>
        <button class="button is-primary" @click.prevent="redirectToLogin()">
          Log in
        </button>
        <button class="button is-primary" @click.prevent="redirectToRegister()">
          Register
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: 'AuthRequiredModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: null
    }
  },
  methods: {
    redirectToLogin() {
      this.$parent.close()
      this.$router.push({
        name: 'Login'
      })
    },
    redirectToRegister() {
      this.$parent.close()
      this.$router.push({
        name: 'Register'
      })
    },
    closeModal() {
      this.$parent.close()
    }
  }
}
</script>
